import { render, staticRenderFns } from "./CadastroCategoria.vue?vue&type=template&id=48b9174c"
import script from "./CadastroCategoria.vue?vue&type=script&lang=js"
export * from "./CadastroCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports